import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { FormGroup } from 'reactstrap';
import { H5, P, UL } from '../../../AbstractElements';
import SocialAuth from './SocialAuth';

const SignInWith = ({ t }) => {
    return (
        <Fragment>
            <P>{t("Already have an password?")}
                <Link className='ms-2' to={'/login'}>{t("Sign In")}</Link>
            </P>
        </Fragment>
    );
};
export default SignInWith;
